import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DbService } from '../core/db/db.service';
import { Task } from './task.model';
import { LoggerService } from '../core/logger/logger.service';
import { takeWhile } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';

@Injectable({
    providedIn: 'root',
})
export class TasksService {
    private currentTaskListData: Array<Task> = []; // holds the building plans data
    public currentTaskList$ = new BehaviorSubject<Task[]>(this.currentTaskListData); // subscribeable subject to get current task list
    public taskListLoading$ = new BehaviorSubject<boolean>(true);

    public loadProjectList$ = new EventEmitter();

    private taskListInitialized = false; // true as soon as the task list has been intialized after app is ready

    constructor(
        private db: DbService,
        private logger: LoggerService,
        private authSrv: AuthService
    ) {
        // wait until app is ready
        this.authSrv.appReady$.pipe(takeWhile(() => this.taskListInitialized === false)).subscribe(async (appReady) => {
            if (appReady === true) {
                this.logger.log('[TASKS SERVICE] app ready event received. initializing now');
                this.taskListLoading$.next(true);

                // get task list from db
                this.db.getItemsByType('task').subscribe((res: any[]) => {
                    this.logger.log('[TASKS SERVICE] task list loaded');
                    this.currentTaskListData = [];
                    for (let entry of res) {
                        this.currentTaskListData.push(new Task(entry));
                    }

                    this.currentTaskList$.next(this.currentTaskListData);
                    this.taskListInitialized = true;
                    this.taskListLoading$.next(false);
                });

                // subscribe to itemChanged event from db, to observe project changes
                this.handleItemChanges();
            }
        });
    }

    /**
     * Handles the item changes as soon as an change event has occured in db
     */
    private handleItemChanges() {
        this.logger.log('[TASK SERVICE] subscribing to db item changefeed, to observe task changes');
        this.db.itemsChanged$.subscribe((changes) => {
            for (let change of changes) {
                if (change.item.type === 'task') {
                    let taskIndex = this.currentTaskListData.findIndex((x) => x._id === change.item._id);
                    if (change.operation === 'PUT') {
                        if (taskIndex > -1) {
                            // existing report in list changed, update
                            this.logger.log('[TASK SERVICE] task updated in db. updating current task list.');
                            this.currentTaskListData[taskIndex] = new Task(change.item);
                        } else {
                            // new task added to list
                            let taskToAdd = new Task(change.item);
                            this.currentTaskListData.push(taskToAdd);
                        }
                    } else if (change.operation === 'DELETE' && taskIndex > -1) {
                        this.logger.log('[TASK SERVICE] task deleted in db. updating current task list.');
                        this.currentTaskListData.splice(taskIndex, 1);
                    }
                    this.currentTaskList$.next(this.currentTaskListData);
                }
            }
        });
    }
}
